import { createCoords as b, rectToClientRect as V, round as E, floor as F, max as H, min as _ } from "./atoms-v2865.js";
import { getOverflowAncestors as T, isElement as q, getWindow as O, getFrameElement as A, getComputedStyle as W, getDocumentElement as D, isHTMLElement as M, isWebKit as $ } from "./atoms-v2866.js";
function N(e) {
  const t = W(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const s = M(e), c = s ? e.offsetWidth : n, i = s ? e.offsetHeight : r, o = E(n) !== c || E(r) !== i;
  return o && (n = c, r = i), {
    width: n,
    height: r,
    $: o
  };
}
function C(e) {
  return q(e) ? e : e.contextElement;
}
function B(e) {
  const t = C(e);
  if (!M(t))
    return b(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: s,
    $: c
  } = N(t);
  let i = (c ? E(n.width) : n.width) / r, o = (c ? E(n.height) : n.height) / s;
  return (!i || !Number.isFinite(i)) && (i = 1), (!o || !Number.isFinite(o)) && (o = 1), {
    x: i,
    y: o
  };
}
const U = /* @__PURE__ */ b(0);
function K(e) {
  const t = O(e);
  return !$() || !t.visualViewport ? U : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function j(e, t, n) {
  return !1;
}
function I(e, t, n, r) {
  t === void 0 && (t = !1);
  const s = e.getBoundingClientRect(), c = C(e);
  let i = b(1);
  t && (i = B(e));
  const o = j() ? K(c) : b(0);
  let a = (s.left + o.x) / i.x, f = (s.top + o.y) / i.y, v = s.width / i.x, p = s.height / i.y;
  if (c) {
    const w = O(c), h = r;
    let g = w, u = A(g);
    for (; u && r && h !== g; ) {
      const d = B(u), l = u.getBoundingClientRect(), m = W(u), x = l.left + (u.clientLeft + parseFloat(m.paddingLeft)) * d.x, R = l.top + (u.clientTop + parseFloat(m.paddingTop)) * d.y;
      a *= d.x, f *= d.y, v *= d.x, p *= d.y, a += x, f += R, g = O(u), u = A(g);
    }
  }
  return V({
    width: v,
    height: p,
    x: a,
    y: f
  });
}
function S(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function G(e, t) {
  let n = null, r;
  const s = D(e);
  function c() {
    var o;
    clearTimeout(r), (o = n) == null || o.disconnect(), n = null;
  }
  function i(o, a) {
    o === void 0 && (o = !1), a === void 0 && (a = 1), c();
    const f = e.getBoundingClientRect(), {
      left: v,
      top: p,
      width: w,
      height: h
    } = f;
    if (o || t(), !w || !h)
      return;
    const g = F(p), u = F(s.clientWidth - (v + w)), d = F(s.clientHeight - (p + h)), l = F(v), x = {
      rootMargin: -g + "px " + -u + "px " + -d + "px " + -l + "px",
      threshold: H(0, _(1, a)) || 1
    };
    let R = !0;
    function L(z) {
      const y = z[0].intersectionRatio;
      if (y !== a) {
        if (!R)
          return i();
        y ? i(!1, y) : r = setTimeout(() => {
          i(!1, 1e-7);
        }, 1e3);
      }
      y === 1 && !S(f, e.getBoundingClientRect()) && i(), R = !1;
    }
    try {
      n = new IntersectionObserver(L, {
        ...x,
        // Handle <iframe>s
        root: s.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(L, x);
    }
    n.observe(e);
  }
  return i(!0), c;
}
function Q(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: s = !0,
    ancestorResize: c = !0,
    elementResize: i = typeof ResizeObserver == "function",
    layoutShift: o = typeof IntersectionObserver == "function",
    animationFrame: a = !1
  } = r, f = C(e), v = s || c ? [...f ? T(f) : [], ...T(t)] : [];
  v.forEach((l) => {
    s && l.addEventListener("scroll", n, {
      passive: !0
    }), c && l.addEventListener("resize", n);
  });
  const p = f && o ? G(f, n) : null;
  let w = -1, h = null;
  i && (h = new ResizeObserver((l) => {
    let [m] = l;
    m && m.target === f && h && (h.unobserve(t), cancelAnimationFrame(w), w = requestAnimationFrame(() => {
      var x;
      (x = h) == null || x.observe(t);
    })), n();
  }), f && !a && h.observe(f), h.observe(t));
  let g, u = a ? I(e) : null;
  a && d();
  function d() {
    const l = I(e);
    u && !S(u, l) && n(), u = l, g = requestAnimationFrame(d);
  }
  return n(), () => {
    var l;
    v.forEach((m) => {
      s && m.removeEventListener("scroll", n), c && m.removeEventListener("resize", n);
    }), p == null || p(), (l = h) == null || l.disconnect(), h = null, a && cancelAnimationFrame(g);
  };
}
export {
  Q as autoUpdate,
  T as getOverflowAncestors
};
